const NEWS_TYPE = {
  ONLY_TITLE: 1,
  TEXT: 2,
  HTML: 3,
} as const;

type NewsType = ValueOf<typeof NEWS_TYPE>;

const NEWS_RELEASE_TYPE = {
  USER: 1,
  SHOP: 2,
  BOTH: 3,
} as const;

type NewsReleaseType = ValueOf<typeof NEWS_RELEASE_TYPE>;

export type NewsItem = {
  id: number;
  release_type: NewsReleaseType;
  news_type: NewsType;
  path: string;
  title: string;
  detail_text: string;
  start_datetime: string;
};

export type UnreadNewsItem = NewsItem["id"];

const create = (args: Partial<NewsItem> = {}): NewsItem => ({
  id: 0,
  release_type: NEWS_RELEASE_TYPE.USER,
  news_type: NEWS_TYPE.ONLY_TITLE,
  path: "",
  title: "",
  detail_text: "",
  start_datetime: "",
  ...args,
});

const getDetailTextMultiLine = (newsItem: NewsItem): string[] =>
  newsItem.detail_text.split("\n");

export const NewsItem = {
  create,
  getDetailTextMultiLine,
} as const;
